import React from "react";

import classes from "./FileMedium.module.scss";
import pinnedImage from "../../../assets/icons/pinned.svg";
import pinnableImage from "../../../assets/icons/pinable.svg";
import folderColor1 from "../../../assets/icons/folder_color-1.svg";
import folderColor2 from "../../../assets/icons/folder_color-2.svg";
import folderColor3 from "../../../assets/icons/folder_color-3.svg";
import folderColor4 from "../../../assets/icons/folder_color-4.svg";
import folderColor5 from "../../../assets/icons/folder_color-5.svg";
import folderColor6 from "../../../assets/icons/folder_color-6.svg";
import folderColorPrimary from "../../../assets/icons/folder_primary.svg";
import filePrimary from "../../../assets/icons/file_pdf.svg";
import Dropdown from "../../UI/DropDown/DropDown";
import ItemNameIcon from "../../ListView/ListViewRows/ItemNameIcon/ItemNameIcon";
import { getParsedDate } from "../../../helper";
import SharedIcon from "../../UI/SharedIcon/SharedIcon";

const colors = [
  null,
  folderColor1,
  folderColor2,
  folderColor3,
  folderColor4,
  folderColor5,
  folderColor6,
  folderColorPrimary,
];

const fileMedium = (props) => {
  const pinnedClass = props.hoverId === props.folderId ? "show" : "hide";
  let pinned;
  if (props.pinned) {
    pinned = (
      <div className={[classes["pinned-box"], "d-flex"].join(" ")}>
        <img alt="PinnedIcon" src={pinnedImage} className="img-fluid" />
      </div>
    );
  } else {
    pinned = (
      <div className={[classes["pinned-box"], "d-flex", pinnedClass].join(" ")}>
        <img alt="PinnedIcon" src={pinnableImage} className="img-fluid" />
      </div>
    );
  }

  let folderActivity = (
    <>
      <div className={[classes["file-icon"], "ml-4"].join(" ")}>
        {props.isDocuments ? (
          <img
            onClick={() => props.onClick(props.item.id)}
            alt="File Icon"
            width="36"
            height="36"
            src={filePrimary}
          ></img>
        ) : (
          <ItemNameIcon
            itemIcon={props.isFolder ? colors[props.color] : filePrimary}
            item={props.item}
            isFolder={props.isFolder}
            rootFolderId={props.rootFolderId}
            isArchivedView={props.isArchivedView}
            isGrid={true}
            {...props}
          />
        )}
      </div>
      <div className="pl-2">
        <div className={[classes["title-container"], "d-flex"].join(" ")}>
          <div className={[classes["title"], "is-size-body-1 bold"].join(" ")}>
            {props.title}
          </div>
          <SharedIcon
            isFolder={props.isFolder}
            itemId={props.isFolder ? props.item.folderId : props.item.id}
            position="right"
          />
        </div>
        <div
          className={[classes["last-opened"], "is-size-body-2", "mt-1"].join(
            " "
          )}
        >
          {/* Opened {props.lastOpenedValue} {props.lastOpenedUnit} ago. */}
          Modified{" "}
          {getParsedDate(props.item.modifiedTs).includes("ago")
            ? getParsedDate(props.item.modifiedTs)
            : `on ${getParsedDate(props.item.modifiedTs)}`}
        </div>
      </div>
    </>
  );

  const getContentRole = (userRoleId) => {
    const folder = props.item;
    if (userRoleId === 1 || userRoleId === 2) {
      return [true, { role: "Owner" }];
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = [true, { role: "Owner" }];
      } else {
        const sharedFolderArr = props.isDocuments
          ? folder.sharedDocument
          : folder.sharedFolder;
        const sharedUsers = sharedFolderArr.map((sharedItem) => {
          return {
            id: sharedItem.user.id,
            role: sharedItem.userRole.name,
          };
        });
        const getAccess = sharedUsers.find(
          (sharedUser) =>
            sharedUser.id === logUserId &&
            (sharedUser.role === "Owner" || sharedUser.role === "Collaborator")
        );
        returnedVal = getAccess ? [true, getAccess] : [false];
      }
      return returnedVal;
    }
  };

  return (
    <div
      className={[classes["file-medium"], "d-flex", "mx-4 my-3"].join(" ")}
      onMouseOver={props.isColumns.isPinned ? props.pinOverHandler : null}
      onMouseOut={props.isColumns.isPinned ? props.pinOutHandler : null}
    >
      {/* LEFT
      - checkbox
      - file-icon
      - title
      - shared-icon
      - last-opened */}
      <div className={[classes["file-medium-left"], "d-flex"].join(" ")}>
        <div className="ml-3">
          <input
            type="checkbox"
            checked={props.checked}
            className={classes["checkbox"]}
            onChange={props.checkedHandler}
          />
        </div>
        {props.isDocuments ? (
          <>{folderActivity}</>
        ) : (
          <>
            {/* <NavLink
              to={`/files/${props.rootFolderId}/${props.subFolderId}`}
              style={{ display: "contents" }}
            > */}
            {folderActivity}
            {/* </NavLink> */}
          </>
        )}
      </div>

      {/* RIGHT
      - pinned-icon
      - more-options-icon */}
      <div className={classes["file-medium-right"]}>
        <div className={[classes["file-medium-right-row"], "d-flex"].join(" ")}>
          {props.isFolder ? (
            <div className={classes["pinned"]} onClick={props.pinHandler}>
              {pinned}
            </div>
          ) : null}
          {/* <div className={[classes["more"], "mt-4"].join(" ")}>
            <img alt="more" src={moreImage} className="img-fluid" />
          </div> */}
          {props.isColumns.isDropDown ? (
            getContentRole(props.userRoleId)[0] ? (
              <div className={[classes["more"], "mt-4"].join(" ")}>
                <Dropdown
                  isDocumentView={props.isDocumentView}
                  contentAccess={getContentRole(props.userRoleId)[1]}
                  documentEdit={props.item.file}
                  handleEdit={(e) => {
                    e.preventDefault();
                    return props.item.fileUrl
                      ? props.documentOnClickHandler(props.item.id, false)
                      : props.setEditFolder(true, props.item);
                  }}
                  handleShare={(e) => {
                    e.preventDefault();
                    props.setShareFolder(props.item);
                  }}
                  handleArchive={() => {
                    const id = props.item.id || props.item.folderId;
                    props.setArchiveModalVisibility(true, props.item.title, id);
                  }}
                  setMoveFileModalVisibility={() =>
                    props.setMoveFileModalVisibility(props.item.id)
                  }
                />
              </div>
            ) : null
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default fileMedium;
